import { render, staticRenderFns } from "./ButtonTranslateArticle.vue?vue&type=template&id=551a3372"
import script from "./ButtonTranslateArticle.vue?vue&type=script&lang=ts"
export * from "./ButtonTranslateArticle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports